import styled from "styled-components";

export const SelectContainer = styled.div`
  margin-right: 40px;
  max-width: 264px;
`;

export const EnvironmentTableCell = styled.div`
  width: ${(props: { width: string }) => props.width};
`;

export const EnvironmentTableRow = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 0;
  border-bottom: 1px solid;
  border-color: var(--section-stone-border-color, var(--stone));
`;
